export const AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS =
  'e36c4531-99b6-4a9a-b523-451cca8bf286';

export const PROMPT_HUB_PROMPTS_ID = {
  SECTION_GENERATION: '045a7a65-ed6b-4cfa-bb1b-fb276595e1fb',
};

export enum PromptParams {
  USER_INSTRUCTION = 'User instruction',
  ALLOWED_COMPONENTS = 'allowed components',
  BUSINESS_TYPE = 'business type',
  BUSINESS_NAME = 'business name',
  TONE_OF_VOICE = 'tone of voice',
}
